<template>
        <div class="left">
                <div class="logo2">
                    <img :src="fromL.basics.logo ? fromL.basics.logo : require('../assets/img/moren.png')" alt="">
                </div>

                <!-- 权限 -->
                <div style="width: 100%;" v-for="(item,index) in appSignL(barList)"
                    :key="index+1">
                    <!-- 渲染平台工具类型 -->
                    <div style="width: 100%;" @click.stop="goto(item,index)">
                        <div class="ulTOne" >
                                <div class="menu_left">
                                    <img class="logo"  
                                    :src="activeL === (index +1) ? item.url[0].menuActiveIcon : item.url[0].menuIcon" 
                                    alt="">
                                    <span class="barT" :style="{color : activeL === (index +1) ? '#0051D7' :''}">
                                        {{ item.name }}
                                    </span>
                                </div>
                        </div>
                    </div>
                </div>

        </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import store from '../store'
import { myMixin } from "@/mixins/mixin.js"

    export default {
        mixins: [ myMixin ],
        props:['cocoNoteType'],
        computed: {
            ...mapGetters(['userinfo','userinfo2','fromL','appSign']),
            // 筛选是否为管理员可见，是否被删除
            appSignL(){
                return function(val){
                    let data = []
                    
                    val.forEach(e =>{
                        if (e.toolId === 'futureClassType' && this.cocoNoteType == 'coconote') {
                            data.push(e)
                        }
                        if (e.toolId === 'person' && this.cocoNoteType == 'person') {
                            data.push(e)
                        }
                        if (e.toolId === 'learning' && this.roleUser.type == 1 && this.cocoNoteType == 'learning') {
                            data.push(e)
                        }
                        if (e.toolId === 'learning/studentProjectList' && this.roleUser.type == 2 && this.cocoNoteType == 'learning') {
                            data.push(e)
                        }
                        if (e.toolId === 'classroomOb' && this.cocoNoteType == 'classroomOb') {
                            data.push(e)
                        }
                    })

                    if (this.roleUser.type == 1) {
                        data.push(
                            {
                                name:'学生管理',
                                toolId: "project",
                                argumentList: [
                                    "userid",
                                    "oid",
                                    "classId",
                                    "org",
                                    "role"
                                ],
                                url: [
                                    {
                                        region: "cn",
                                        url: "https://pbl.cocorobo.cn/pbl-teacher-table/dist/#/student",
                                        name: "学生管理",
                                        menuIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%AD%A6%E7%94%9F%E7%AE%A1%E7%90%861758628251713.svg',
                                        menuActiveIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E5%AD%A6%E7%94%9F%E7%AE%A1%E7%90%86%20%281%291758628255157.svg'
                                    },
                                    {
                                        region: "beta",
                                        url: "https://beta.pbl.cocorobo.cn/pbl-teacher-table/dist/#/student",
                                        name: "学生管理",
                                        menuIcon:'',
                                        menuActiveIcon:''
                                    },
                                ],
                            },
                        )
                    }

                    
                    return data
                }
            },
            // 如果hk，com没有图标，默认使用cn的
            AppCon(){
                return function(c) {
                    let data = JSON.parse(JSON.stringify(c))

                    data.forEach(k=>{
                        k.menuIcon = data[0].menuIcon
                        k.menuActiveIcon = data[0].menuActiveIcon
                    })
                    
                    return data
                };
            },
            roleUser(){
                return Object.keys(this.userinfo2).length != 0 ? this.userinfo2 : this.userinfo
            }
        },
        data() {
            return {
                // 一级选中第几个
                activeL: 1,
                barList:[
                    {   
                        name:'跨学科学习',
                        toolId: "futureClassType",
                        argumentList: [
                            "userid",
                            "oid",
                            "org",
                            "role"
                        ],
                        url: [
                            {
                                region: "cn",
                                url: "https://pbl.cocorobo.cn/pbl-teacher-table/dist/#/synergyCourse",
                                name: "跨学科学习",
                                menuIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/apps%20%281%291763449293821.svg',
                                menuActiveIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/apps1763449300318.svg'
                            },
                            {
                                region: "beta",
                                url: "https://beta.pbl.cocorobo.cn/pbl-teacher-table/dist/#/synergyCourse",
                                name: "跨学科学习",
                                menuIcon:'',
                                menuActiveIcon:''
                            },
                        ],
                    },
                    {
                        name:'拔尖人才',
                        toolId: "person",
                        argumentList: [
                            "userid",
                            "oid",
                            "org",
                            "role",
                            "tType"
                        ],
                        url: [
                            {
                                region: "cn",
                                url: "https://pbl.cocorobo.cn/pbl-teacher-table/dist/#/topTalent",
                                name: "拔尖人才",
                                menuIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E6%8B%94%E5%B0%96%E4%BA%BA%E6%89%8D1763449440270.svg',
                                menuActiveIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E6%8B%94%E5%B0%96%E4%BA%BA%E6%89%8D%20%281%291763449466031.svg'
                            },
                            {
                                region: "beta",
                                url: "https://beta.pbl.cocorobo.cn/pbl-teacher-table/dist/#/topTalent",
                                name: "拔尖人才",
                                menuIcon:'',
                                menuActiveIcon:''
                            },
                        ],
                    },
                    {
                        name:'课堂教学评价',
                        toolId: "classroomOb",
                        argumentList: [
                            "userid",
                            "oid",
                            "org",
                            "role"
                        ],
                        url: [
                            {
                                region: "cn",
                                url: "https://pbl.cocorobo.cn/pbl-teacher-table/dist/#/classroomObservation",
                                name: "课堂教学评价",
                                menuIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E8%AF%BE%E5%A0%82%E8%A7%82%E5%AF%9F%E6%95%B0%E6%8D%AE%E5%88%86%E6%9E%90%EF%BC%88%E7%BA%BF%E6%80%A7%EF%BC%891763460227583.svg',
                                menuActiveIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/%E8%AF%BE%E5%A0%82%E8%A7%82%E5%AF%9F%E6%95%B0%E6%8D%AE%E5%88%86%E6%9E%90%EF%BC%88%E7%BA%BF%E6%80%A7%EF%BC%89%20%281%291763460243446.svg'
                            },
                            {
                                region: "beta",
                                url: "https://beta.pbl.cocorobo.cn/pbl-teacher-table/dist/#/classroomObservation",
                                name: "课堂教学评价",
                                menuIcon:'',
                                menuActiveIcon:''
                            },
                        ],
                    },
                    {
                        name:'个性化学习中心',
                        toolId: "learning",
                        argumentList: [
                            "userid",
                            "oid",
                            "org",
                            "role"
                        ],
                        url: [
                            {
                                region: "cn",
                                url: "https://beta.app.cocorobo.cn/#/learning",
                                name: "个性化学习中心",
                                menuIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/athetop1763461509812.svg',
                                menuActiveIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/athetop%20%281%291763461514803.svg'
                            },
                            {
                                region: "beta",
                                url: "https://beta.app.cocorobo.cn/#/learning",
                                name: "个性化学习中心",
                                menuIcon:'',
                                menuActiveIcon:''
                            },
                        ],
                    },
                    {
                        name:'个性化学习中心',
                        toolId: "learning/studentProjectList",
                        argumentList: [
                            "userid",
                            "oid",
                            "org",
                            "role"
                        ],
                        url: [
                            {
                                region: "cn",
                                url: "https://beta.app.cocorobo.cn/#/learning/studentProjectList",
                                name: "个性化学习中心",
                                menuIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/athetop1763461509812.svg',
                                menuActiveIcon:'https://ccrb.s3.cn-northwest-1.amazonaws.com.cn/athetop%20%281%291763461514803.svg'
                            },
                            {
                                region: "beta",
                                url: "https://beta.app.cocorobo.cn/#/learning/studentProjectList",
                                name: "个性化学习中心",
                                menuIcon:'',
                                menuActiveIcon:''
                            },
                        ],
                    }
                ]
            }
        },
        methods: {
            ...mapActions({
                logout: 'user/logout'
            }),
            
            mouGet(val){
                
                if(!val.includes('appStore')) return
                // console.log('val',val);
                this.getData()
            },
            // 点击一级导航
            async goto(val = null,index){
                console.log('goto',index,val);

                try {
                    window.topU.gotype = '' 
                } catch (error) {
                    console.log(error);
                }

                this.activeL = index + 1            

                console.log('this.appSign',this.appSign);
                console.log('val.toolId',val.toolId);
                // 点击相同应用不刷新  
                if (this.appSign == val.toolId) return

                // 更新标识
                await store.commit('user/SET_AppSIGN', val.toolId)

                let url = ''
                // 查出对应账号的应用区域地址
                val.url.forEach(e => {
                    // if (e.region == this.roleUser.schoolArea || e.region == this.roleUser.orgArea) {
                    if (e.region == this.$region) {
                        url = e.url
                    }
                });
                
                let _userinfo = this.roleUser, //登录用户信息
                { userid: _userid, organizeid: _oid, type: _type, org: _org, role: _role, classid: _classId } = _userinfo; // 解构赋值获取用户信息
                const _TscreenType = 1, _SscreenType = 3; // 常量定义
                let queryString = ''
                if(val.argumentList && val.argumentList.length){
                    const paramsMap = {
                        userid: _userid,
                        org: _org,
                        oid: _oid,
                        tType: _type,
                        role: _role,
                        classId: _classId,
                        TscreenType: _TscreenType,
                        SscreenType: _SscreenType
                    };

                    const canshu = val.argumentList
                .filter(param => paramsMap[param] !== undefined || param === 'type')
                .map(param => param === 'type' ? `tType=${paramsMap['tType']}` : `${param}=${paramsMap[param]}`);
                    queryString = canshu.length ? (url.includes('?') ? '&' : '?') + canshu.join('&') : ''; // 生成查询字符串
                }

                let _url = url + queryString
                // if (val.toolId == "futureClass") {
                //     _url = url + queryString +'&ly=1&person=liyuan'
                // } else if (val.toolId == "AIPopCourse") {
                //     // 为了隐藏侧边栏与顶部 
                //     _url = url + queryString +'&gotype=1'
                // } else if (val.toolId == "classroomOb") {
                //     _url = url + queryString +'&showIntroduceType=1'
                // } else{
                //     _url = url + queryString
                // }
                // if(val.toolId == 'study' && this.roleUser.type == 2){
                //     _url = _url.replace(/([?&])classId=([^&]*)/, '$1cid=$2');
                // }
                // console.log('_url',_url);

                let pl = {json:_url ,stateL :true,toolId :val.toolId}
                // console.log('pl',pl);
                

                // 添加打开应用
                this.$emit('AddAppJson',pl)

                // this.addOp3('1', "", { type:this.prefixL + val.toolId + (this.roleUser.type == 1 ? '_teacher' : '_student') + "_open" }, "success")

            },
        },
       
       
    }
</script>

<style scoped>

.left {
    font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
    width: 80px;
    height: 100%;
    padding:23px 6px;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    overflow: auto;
    border-right: 1px #D5D5D5 solid;
}

.ulTOne{ 
    width: 100%;
    border-radius: 10px;
    display: flex;
    height: 48px;
    flex-wrap:nowrap;
    align-content: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
}


.barT{
    font-size:10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.menu_left {
  width: 32px;
  height: 42px;
  font-size: 10px;
  color: #64748b;
  box-sizing: border-box;
  cursor: pointer;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.logo2 {
    cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  background-color: #fff;
  text-align: center;
}
.logo2 img{
    width: 60px;
    height: 60px;
}

/* .menu_left {
  width: 32px;
  font-size: 10px;
  color: #64748b;
  box-sizing: border-box;
  cursor: pointer;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
} */
.logo{
  margin: auto;
  width: 24px;
  height: 24px;
}
.barY{
    width: 100%;
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.left::-webkit-scrollbar { width: 0px; } 
.left { scrollbar-width: none; }
</style>